import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { getIntubationSelector } from '../selectors'
import { setAddToTimeLine } from '../store/intubation.actions'
import { IntubationConstants } from '../store/intubation.constants'
import { IIntubationState } from '../store/intubation.types'
import { addIntubationItem } from '../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../utilities/nemsisCode.util'

export function* saveIntubation() {
  const intubationStateWithDefaults: IIntubationState = yield select(getIntubationSelector)
  let intubationState: IIntubationState = {
    ...intubationStateWithDefaults,
    intubationDefaults: null,
  }

  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)
  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    intubationState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: intubationState,
      actionField: (s) => s.method.name,
      filter1Field: (s) => s.verificationVia?.id?.toString(), // verification via (any value)
      filter2Field: (s) => s.rSIProtocol?.id?.toString(), // rsi protocol (0-no or 1-yes)
      filter3Field: (s) => s.securedVia?.id?.toString(), // tube secured via (amb.tb_prtube_secured_via)
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    intubationState = handleNemsisCodeError(error, intubationState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.intubationStateList && pcrDoc.patient?.intubationStateList.length) {
    const index = pcrDoc.patient?.intubationStateList?.findIndex((intubation) => intubation.key === intubationState.key)
    if (index !== -1) {
      pcrDoc.patient.intubationStateList[index] = intubationState
    } else {
      pcrDoc.patient?.intubationStateList.push(intubationState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, intubationStateList: [intubationState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addIntubationItem())
  } catch (e) {
    yield put(throwPcrException(`saveIntubation() error: ${e}`))
  }
}

export function* saveIntubationSaga() {
  yield takeLatest(
    [
      IntubationConstants.SAVE_INTUBATION,
      IntubationConstants.SET_DATE_TIME,
      IntubationConstants.SET_DATE,
      IntubationConstants.SET_TIME,
      IntubationConstants.SET_ASSESSED_BY,
      IntubationConstants.SET_ABANDONED_DATE,
      IntubationConstants.SET_ABANDONED_TIME,
      IntubationConstants.SET_ABANDONED_DATE_TIME,
      IntubationConstants.SET_DECISION_TO_MANAGE_DATE_TIME,
      IntubationConstants.SET_DECISION_TO_MANAGE_TIME,
      IntubationConstants.SET_DECISION_TO_MANAGE_DATE,
      IntubationConstants.SET_INDICATIONS,
      IntubationConstants.SET_RESPONSE,
      IntubationConstants.SET_RESPONSE_PNNV,
      IntubationConstants.SET_PROCEDURE_COMPLICATIONS,
      IntubationConstants.SET_AIRWAY_COMPLICATIONS,
      IntubationConstants.SET_AIRWAY_COMPLICATIONS_PNNV,
      IntubationConstants.SET_VERIFICATION_VIA,
      IntubationConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE,
      IntubationConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE_PNNV,
      IntubationConstants.SET_AUTHORIZATION,
      IntubationConstants.SET_ATTEMPTS,
      IntubationConstants.SET_ROLE_PERFORMING,
      IntubationConstants.SET_ROLE_PERFORMING_PNNV,
      IntubationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      IntubationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      IntubationConstants.SET_PTA,
      IntubationConstants.SET_REASONS_FOR_FAILURE,
    ],
    performWithMutexHOG,
    saveIntubation
  )
}
